export function initTabs() {
    const tabsContainers = document.querySelectorAll('[data-tabs]');
    
    if (tabsContainers.length === 0) return;
    
    tabsContainers.forEach(container => {
        const tabButtons = container.querySelectorAll('[data-tab-button]');
        const tabPanels = container.querySelectorAll('[data-tab-panel]');
        const tabsList = container.querySelector('[role="tablist"]');
        
        if (tabButtons.length === 0 || tabPanels.length === 0) return;
        
        // Animation configuration
        const ANIMATION_CONFIG = {
            fadeOutDuration: 200,      // Duration for fade out (ms)
            fadeInDuration: 400,       // Duration for fade in and slide (ms)
            slideDistance: 30          // Distance to slide up in pixels
        };
        
        // Function to scroll tab into view
        function scrollTabIntoView(button) {
            if (!tabsList) return;
            
            const scrollContainer = tabsList.parentElement;
            if (!scrollContainer) return;
            
            // Only scroll on smaller screens
            if (window.innerWidth < 768) {
                const buttonRect = button.getBoundingClientRect();
                const containerRect = scrollContainer.getBoundingClientRect();
                
                // Calculate the scroll position to center the button
                const scrollLeft = button.offsetLeft - (containerRect.width / 2) + (buttonRect.width / 2);
                
                scrollContainer.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
        }
        
        // Function to animate content out
        function animateOut(panel) {
            return new Promise((resolve) => {
                const content = panel.querySelector('[data-tab-content]');
                if (!content) {
                    resolve();
                    return;
                }
                
                content.style.transition = `opacity ${ANIMATION_CONFIG.fadeOutDuration}ms ease, transform ${ANIMATION_CONFIG.fadeOutDuration}ms ease`;
                content.style.opacity = '0';
                content.style.transform = `translateY(-${ANIMATION_CONFIG.slideDistance / 2}px)`;
                
                setTimeout(() => {
                    resolve();
                }, ANIMATION_CONFIG.fadeOutDuration);
            });
        }
        
        // Function to animate content in
        function animateIn(panel) {
            const content = panel.querySelector('[data-tab-content]');
            if (!content) return;
            
            // Set initial state
            content.style.opacity = '0';
            content.style.transform = `translateY(${ANIMATION_CONFIG.slideDistance}px)`;
            content.style.transition = `opacity ${ANIMATION_CONFIG.fadeInDuration}ms ease, transform ${ANIMATION_CONFIG.fadeInDuration}ms ease`;
            
            // Trigger animation on next frame
            requestAnimationFrame(() => {
                content.style.opacity = '1';
                content.style.transform = 'translateY(0)';
            });
        }
        
        // Function to switch tabs with animation
        async function switchTab(index) {
            // Find current active panel
            const currentPanel = Array.from(tabPanels).find(panel => 
                !panel.classList.contains('hidden')
            );
            const targetPanel = tabPanels[index];
            
            // If switching to the same panel, do nothing
            if (currentPanel === targetPanel) return;
            
            // Update buttons immediately
            tabButtons.forEach((button, i) => {
                const isActive = i === index;
                button.classList.toggle('font-bold', isActive);
                button.classList.toggle('text-red', isActive);
                button.classList.toggle('border-b-1', isActive);
                button.classList.toggle('border-red', isActive);
                button.classList.toggle('text-black/64', !isActive);
                button.setAttribute('aria-selected', isActive);
            });
            
            // Scroll active tab into view
            scrollTabIntoView(tabButtons[index]);
            
            // Animate panel transition
            if (currentPanel) {
                // Fade out current panel
                await animateOut(currentPanel);
                
                // Hide current panel
                currentPanel.classList.add('hidden');
                currentPanel.setAttribute('aria-hidden', 'true');
            }
            
            // Show target panel
            targetPanel.classList.remove('hidden');
            targetPanel.setAttribute('aria-hidden', 'false');
            
            // Animate in target panel
            animateIn(targetPanel);
        }
        
        // Add click handlers to tab buttons
        tabButtons.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                switchTab(index);
            });
        });
        
        // Initialize first tab with animation
        if (tabButtons.length > 0 && tabPanels.length > 0) {
            const firstPanel = tabPanels[0];
            // Animate in the first panel on load
            animateIn(firstPanel);
        }
    });
}
